// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__txRPT","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3W-r2"};